import { Chip, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';

function ProjectTag(props) {
    return (
        <Box sx={{mx: .5}}>
            <Chip label={props.tag} sx={{ backgroundColor: '#FFC904', color: 'black', fontWeight: 'bold' }}></Chip>
        </Box>
    );
}

export default ProjectTag;